





































import { Component, Vue, Watch, Inject, Prop } from 'vue-property-decorator';
import SurveyAnswer from '@/models/SurveyAnswer';
import Advertisement from '@/components/Advertisement.vue';
import CustomAcknowledgment from '@/components/CustomAcknowledgment.vue';
import JourneyParameters from '../models/interfaces/JourneyParameters';
import Instance from '@/models/interfaces/Instance';

@Component({ components: { Advertisement, CustomAcknowledgment } })
export default class CompleteView extends Vue {
  @Prop() public value!: SurveyAnswer;
  @Prop() public parameters!: JourneyParameters;
  @Prop() public instance!: Instance;
  @Prop() public readonly journeyId!: number;

  public get whiteMode(): boolean {
    // TODO: Verificar 'white' e 'WHITE'
    return this.parameters.color === '#ffffff';
  }
}
